import { Table } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilter } from '../../util/api/queryWithFilter';
import { queryWithFilterAndPages } from '../../util/api/queryWithFilterAndPages';
import '@mantine/charts/styles.css';
import { Title } from '../../components/Title';
import { formatToDateString } from '../../util/formatting';
import { ExportButton } from '../export/ExportButton';
import type { NearMissDto } from './types/NearMissDto';
import { KeyedRow } from '../../components/KeyedRow';

export function NearMisses() {
	const { organisation } = useParams();
	const filter = useFilter();
	const pagination = usePagination();

	const nearMissQuery = queryWithFilterAndPages<NearMissDto[]>(
		`${organisation}/near-misses/all`,
		filter.value,
		pagination.value,
	);

	const nearMissCountQuery = queryWithFilter<number>(
		`${organisation}/near-misses/count`,
		filter.value,
	);

	return (
		<>
			<PageHeader
				title={'Near Misses'}
				filter={filter}
				filterOnSameLine
				rightContent={
					<ExportButton apiPath={`${organisation}/near-misses/export`} />
				}
			/>
			<DataTable
				pagination={pagination}
				totalItems={nearMissCountQuery.data?.value ?? 100}
				isRowsLoading={nearMissQuery.isLoading}
				isPaginationLoading={nearMissCountQuery.isLoading}
				rows={pagination.value.pageSize}
				highlightOnHover
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th><Title label={'Edit Date'} /></Table.Th>
						<Table.Th><Title label={'Branch'} /></Table.Th>
						<Table.Th><Title label={'Practice Code'} /></Table.Th>
						<Table.Th><Title label={'Description'} /></Table.Th>
						<Table.Th><Title label={'Old Value'} /></Table.Th>
						<Table.Th><Title label={'New Value'} /></Table.Th>
						<Table.Th><Title label={'Edit Description'} /></Table.Th>
						<Table.Th><Title label={'Staff Member'} /></Table.Th>
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{nearMissQuery.data?.value.map((nearMiss) => (
						<KeyedRow key={nearMiss.id}>
							<Table.Td>{formatToDateString(nearMiss.editDate)}</Table.Td>
							<Table.Td>{nearMiss.branchName}</Table.Td>
							<Table.Td>{nearMiss.nationalPracticeCode}</Table.Td>
							<Table.Td>{nearMiss.description}</Table.Td>
							<Table.Td>{nearMiss.oldValue}</Table.Td>
							<Table.Td>{nearMiss.newValue}</Table.Td>
							<Table.Td>{nearMiss.editDescription}</Table.Td>
							<Table.Td>{`${nearMiss.givenName} ${nearMiss.surname}`}</Table.Td>
						</KeyedRow>
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
